/**
 * Heading ids for guide/nouveautes. Its headings start with an emoji, and the
 * default slugger turned « 🛡️ Cautions » into `-cautions` with an invisible
 * U+FE0F in front, so shared links and « Sur cette page » broke. This drops the
 * leading emoji, then slugs like the rest of the site (accents kept).
 *
 * Shared by the build (zudoku.build.ts, snapshot headings) and the browser
 * (ProductUpdates.tsx, live headings) so both give the same `#id`.
 */
export function headingSlug(text: string): string {
  return text
    .replace(/^[^\p{L}\p{N}]+/u, '')
    .trim()
    .toLowerCase()
    .replace(/[^\p{L}\p{N}\s-]/gu, '')
    .replace(/\s+/g, '-');
}
